function calculatePercentageChange(currentPrice, price24hAgo) {
  const percentageChange = ((currentPrice - price24hAgo) / price24hAgo) * 100;
  return percentageChange.toFixed(2); // This rounds the result to 2 decimal places
}

export default calculatePercentageChange;
